import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Facebook, Instagram } from "lucide-react";
import { NAV, SOCIAL } from "@/lib/data";

const Social = ({ small }) => (
  <div className="flex items-center gap-2">
    {[["facebook", Facebook], ["instagram", Instagram]].map(([k, Icon]) => (
      <a key={k} href={SOCIAL[k]} target="_blank" rel="noreferrer" data-testid={`header-${k}-link`} aria-label={k}
        className={`${small ? "w-7 h-7" : "w-8 h-8"} rounded-full bg-white text-[#333] grid place-items-center shadow hover:text-[var(--iv)] transition-colors`}>
        <Icon className="w-4 h-4" />
      </a>
    ))}
  </div>
);

const NavItems = ({ compact, onClick }) => (
  <>
    {NAV.map((n) => (
      <NavLink key={n.to} to={n.to} end onClick={onClick} data-testid={`nav-${n.to === "/" ? "home" : n.to.slice(1)}-link`}
        className={({ isActive }) =>
          `uppercase font-bold whitespace-nowrap transition-colors ${compact ? "text-[15px] xl:text-[17px] px-3 xl:px-4 py-3.5" : "text-[17px] px-4 py-3.5"} ${
            isActive ? "bg-white text-[var(--iv)]" : "text-white hover:bg-white/15"}`}>
        {n.label}
      </NavLink>
    ))}
  </>
);

export const Header = () => {
  const [sticky, setSticky] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const on = () => setSticky(window.scrollY > 210);
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <header data-testid="site-header">
      <div className="bg-[var(--iv)] relative">
        <div className="max-w-[1440px] mx-auto px-4 h-[96px] lg:h-[150px] flex items-center justify-center relative">
          <Link to="/" data-testid="header-logo-link"><img src="/img/logo_ivcasa_white_sm.png" alt="IVCasa Gruppo Immobiliare" className="h-[62px] lg:h-[112px] w-auto" /></Link>
          <div className="hidden lg:block absolute right-6 top-4"><Social /></div>
          <button className="lg:hidden absolute right-4 text-white p-2" onClick={() => setOpen((o) => !o)} data-testid="nav-mobile-menu-button" aria-label="Menu">
            {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
          </button>
        </div>
        {open && (
          <nav className="lg:hidden flex flex-col bg-[var(--iv-dark)] pb-2" data-testid="mobile-nav">
            <NavItems onClick={() => setOpen(false)} />
            <div className="px-4 pt-3"><Social small /></div>
          </nav>
        )}
      </div>
      <nav className="hidden lg:flex justify-center bg-[var(--iv-dark)] shadow-[0_3px_6px_rgba(0,0,0,0.25)]">
        <NavItems />
      </nav>
      <div className={`hidden lg:block fixed top-0 inset-x-0 z-50 bg-[var(--iv)] shadow-md transition-transform duration-300 ${sticky ? "translate-y-0" : "-translate-y-full"}`} data-testid="sticky-header">
        <div className="flex items-center justify-between pl-1 pr-2 h-[63px]">
          <Link to="/" data-testid="sticky-logo-link"><img src="/img/logo_ivcasa_white_sm.png" alt="IVCasa" className="h-[52px] w-auto" /></Link>
          <nav className="flex items-center"><NavItems compact /></nav>
        </div>
      </div>
    </header>
  );
};
